import { useBilingual } from "@/lib/bilingual";

const BrandPhilosophy = () => {
  const b = useBilingual();
  return (
    <section className="bg-stone-900 py-14 md:py-24">
      <div className="max-w-screen-xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-amber-500 text-xs font-semibold tracking-widest uppercase mb-3">
            {b("Brand Philosophy", "品牌理念")}
          </p>
          <div className="flex items-center justify-center gap-4">
            <span className="block h-px w-16 bg-amber-700/50" />
            <span
              className="text-amber-400 text-2xl"
              style={{ fontFamily: "var(--font-display)" }}
            >
              ✦
            </span>
            <span className="block h-px w-16 bg-amber-700/50" />
          </div>
        </div>

        <div className="max-w-3xl mx-auto border border-stone-700 rounded-2xl p-10 md:p-14">
          <blockquote
            className="text-stone-200 text-lg md:text-xl leading-loose text-center"
            style={{ fontFamily: "var(--font-display)" }}
          >
            {b(
              "\u201CHome is the center of all in such a busy life, where the aesthetics of living becomes the taste and pursuit for successful people everywhere. Forwaro Furniture upholds the concept of furniture design and the consistency of quality — bringing your home a place where aesthetics and craftsmanship complement each other.\u201D",
              "「在日益繁忙的生活裡，家是一切的中心。生活美學相對成為成功人士對家的追求與品味。風華國際秉持一貫對家具的設計理念，與生產品質的堅持，希望為所有的家，提升至美學與工藝相輔的層次空間。」",
            )}
          </blockquote>
        </div>
      </div>
    </section>
  );
};

export default BrandPhilosophy;
